<div class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-md-9"><h6>Relatórios</h6></div>
    </div>

    <div class="card-body">
      <!-- Nav tabs -->
      <ul
        ngbNav
        #customNav="ngbNav"
        [activeId]="1"
        class="nav nav-tabs nav-tabs-custom"
      >
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
            <span class="d-none d-sm-block">Frotal total</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabFleet"></ng-template>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
            <span class="d-none d-sm-block">Posições ElasticSearch</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template
              [ngTemplateOutlet]="TabLastPositionElastic"
            ></ng-template>
          </ng-template>
        </li>
        <li [ngbNavItem]="3" (click)="requestSummarizedPositionsList()">
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
            <span class="d-none d-sm-block">Posições sumarizadas</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template
              [ngTemplateOutlet]="TabSummarizedPositions"
            ></ng-template>
          </ng-template>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content p-3 text-muted">
        <div [ngbNavOutlet]="customNav"></div>
      </div>
    </div>
  </div>
</div>
<!-- Tab LastFiles-->
<ng-template #TabFleet>
  <button class="btn btn-sm btn-primary m-3" (click)="getReportFleet()">
    Pesquisar
  </button>
  <ng-container *ngIf="circularProgressiveWaitTabFleet > -1">
    <div class="card align-items-center">
      <div card="card-body mt-n3">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="card align-items-center">
          {{ circularProgressiveWaitTabFleetText }}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- <ng-container *ngIf="circularProgressiveWaitTabFleet > -1">
    <div class="mb-4">
      <ngb-progressbar
        [value]="circularProgressiveWaitTabFleet"
        [striped]="true"
        [animated]="true"
        [showValue]="true"
      ></ngb-progressbar>
    </div>
  </ng-container>-->
  <div>
    <label>Usar filtro por raio (m)</label>
    <input
      type="checkbox"
      [(ngModel)]="reportFleetFilterLatLngBool"
      (change)="changeUseMapPoint()"
    />
  </div>
  <ng-container *ngIf="reportFleetFilterLatLngBool">
    <div class="row">
      <div class="col">
        <div class="input-group input-group-sm mb-3">
          <span class="input-group-text" id="inputGroup-Radius"
            >Raio(m)<br />
            {{ reportFleetFilterLatLngRadius / 1000 }} km
          </span>
          <input
            name="model"
            [(ngModel)]="reportFleetFilterLatLngRadius"
            type="number"
            class="form-control"
            step="1000"
            (change)="
              reportFleetFilterLatLng.lng != 0 &&
              reportFleetFilterLatLng.lat != 0
                ? clickMapFleet()
                : null
            "
            aria-describedby="inputGroup-model"
          />
        </div>
      </div>
      <div class="col">
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-text">Latitude</span>
          <input
            type="number"
            class="form-control"
            (ngModelChange)="createMarkersFleet(false)"
            [(ngModel)]="reportFleetFilterLatLng.lat"
            step="0.0001"
          />
        </div>
      </div>
      <div class="col">
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-text">Longitude</span>
          <input
            class="form-control"
            type="number"
            (ngModelChange)="createMarkersFleet(false)"
            [(ngModel)]="reportFleetFilterLatLng.lng"
            step="0.0001"
          />
        </div>
      </div>
      <div class="col">
        <button
          class="btn btn-sm btn-primary"
          *ngIf="
            reportFleetFilterLatLng.lat != 0 && reportFleetFilterLatLng.lng != 0
          "
          (click)="clickMapFleet()"
        >
          Centralizar ponto
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="reportFleet.length > 0">
    <div class="card align-items-center">Pronto para baixar</div>
    <button
      class="btn btn-sm btn-primary mb-4"
      (click)="exportExcelJson('frota', reportFleet)"
    >
      Exportar relatórios de frota
    </button>
    <div class="card">
      <h3>Filtro do Mapa</h3>

      <div class="row">
        <div class="col">
          <div class="w-100 m-3 d-inline">
            <label>Marca</label>
            <ng-select
              id="marcaFilterSelect"
              placeholder="Filtre por marca"
              [(ngModel)]="reportFleetFilterSelect.marca"
              [ngModelOptions]="{ standalone: true }"
              [multiple]="true"
              (change)="createMarkersFleet(false)"
            >
              <ng-option
                *ngFor="let item of reportFleetFilter.marca"
                [value]="item.id"
              >
                {{ item.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col">
          <div class="w-50 m-3 d-inline">
            <label>Modelo</label>
            <ng-select
              id="modeloFilterSelect"
              placeholder="Filtre por modelo"
              [(ngModel)]="reportFleetFilterSelect.modelo"
              [ngModelOptions]="{ standalone: true }"
              [multiple]="true"
              (change)="createMarkersFleet(false)"
            >
              <ng-option
                *ngFor="let item of reportFleetFilter.modelo"
                [value]="item.id"
              >
                {{ item.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="w-100 m-3 d-inline">
            <label>UF</label>
            <ng-select
              id="ufFilterSelect"
              placeholder="Filtre por uf"
              [(ngModel)]="reportFleetFilterSelect.uf"
              [ngModelOptions]="{ standalone: true }"
              [multiple]="true"
              (change)="createMarkersFleet(false)"
            >
              <ng-option
                *ngFor="let item of reportFleetFilter.uf"
                [value]="item.id"
              >
                {{ item.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="w-100 m-3 d-inline">
            <label>Munícipio</label>
            <ng-select
              id="municipioFilterSelect"
              placeholder="Filtre por munícipio"
              [(ngModel)]="reportFleetFilterSelect.municipio"
              [ngModelOptions]="{ standalone: true }"
              [multiple]="true"
              (change)="createMarkersFleet(false)"
            >
              <ng-option
                *ngFor="let item of reportFleetFilter.municipio"
                [value]="item.id"
              >
                {{ item.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4">
        <div class="w-100 m-3 d-inline">
          <label>Bairro</label>
          <ng-select
            id="bairroFilterSelect"
            placeholder="Filtre por bairro"
            [(ngModel)]="reportFleetFilterSelect.bairro"
            [ngModelOptions]="{ standalone: true }"
            [multiple]="true"
            (change)="createMarkersFleet()"
          >
            <ng-option
              *ngFor="let item of reportFleetFilter.bairro"
              [value]="item.id"
            >
              {{ item.name }}
            </ng-option>
          </ng-select>
        </div>
      </div> -->
    </div>
  </ng-container>
  <div id="map" class="w-100" [minHeight]="500" [fluidHeight]></div>

  <!-- <div class="card overflow-auto">

  </div> -->
</ng-template>

<!-- Tab LastFiles -->
<ng-template #TabLastPositionElastic>
  <div class="card">
    <div class="row">
      <div class="col">
        <div>
          É possível que demore um pouco por causa do tamanho do arquivo.
        </div>
      </div>
      <div class="card col-md-3">
        <label>Solicitar relatório de última posição</label>
        <button class="btn btn-primary btn-sm m-2" (click)="downloadFile(1)">
          Solicitar
        </button>
      </div>
    </div>
  </div>
  <div
    class="card align-items-center"
    *ngIf="circularProgressiveWaitReportLastPositions"
  >
    <div card="card-body mt-n3">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>

  <!-- <div class="card-body">
    <table class="table table-fit table-bordered table-hover">
      <thead class="table-primary">
        <tr>
          <th class="text-center" scope="col">Arquivo</th>
          <th class="text-center col-md-1" scope="col">Tamanho</th>
          <th class="text-center" scope="col">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of lastPositionFile; let i = index">
          <td class="text-center" scope="row">
            {{ item.fileName }}
          </td>
          <td class="text-center" scope="row">
            {{ round(item.size / 1000, 2) }}KB /<br />
            {{ round(item.size / 1000000, 2) }}MB
          </td>

          <td class="text-center" scope="row">
            <i
              style="cursor: pointer"
              class="fa fa-download ms-2"
              (click)="requestDownload(item.fileName)"
              aria-hidden="true"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div> -->
</ng-template>

<!-- Tab SummarizedPositions -->
<ng-template #TabSummarizedPositions>
  <div class="card">
    <div class="row">
      <div class="col">
        <ng-select
          class="m-2"
          id="fileTypeSelect"
          placeholder="Selecione um ano"
          [(ngModel)]="filterSummarizedPositionsYearSelect"
          (change)="filterSummarizedPosition()"
        >
          <ng-option
            *ngFor="let year of filterSummarizedPositionsYear"
            [value]="year.year"
          >
            {{ year.year }}
          </ng-option>
        </ng-select>
      </div>
      <div class="col">
        <ng-select
          class="m-2"
          id="fileTypeSelect"
          placeholder="Selecionar um mês"
          [(ngModel)]="filterSummarizedPositionsMonthSelect"
          (change)="filterSummarizedPosition()"
        >
          <ng-option
            *ngFor="let month of filterSummarizedPositionsMonth"
            [value]="month.month"
          >
            {{ month.month }}
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="card overflow-auto">
    <div
      class="card align-items-center"
      *ngIf="circularProgressiveWaitSummarizedPositions"
    >
      <div card="card-body mt-n3">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="reportSummarizedPositionsSearch.length > 0">
      <div class="card-header mt-3">
        <div class="card-body overflow-auto">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th
                  *ngFor="
                    let item of reportSummarizedPositionsSearch[0].split(',')
                  "
                  class="col-md-1 text-center"
                  scope="col"
                >
                  {{ item }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="
                  let itemRow of reportSummarizedPositionsSearch.slice(
                    1,
                    reportSummarizedPositionsSearch.length
                  )
                "
              >
                <td
                  *ngFor="let itemRowItem of itemRow.split(',')"
                  class="text-center"
                  scope="row"
                >
                  {{ itemRowItem }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-10">
            <h6>Lista dos arquivos</h6>
          </div>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-fit table-bordered table-hover">
          <thead class="table-primary">
            <tr>
              <th class="text-center" scope="col">Ano-mês</th>
              <th class="text-center col-md-1" scope="col">FileName</th>
              <th class="text-center" scope="col">Tamanho</th>
              <th class="text-center col-md-1" scope="col">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of reportSummarizedPositionsListFilter;
                let i = index
              "
            >
              <td class="text-center" scope="row">
                {{ item.yearMonth }}
              </td>
              <td class="text-center" scope="row">
                {{
                  item.fileName.split("/")[item.fileName.split("/").length - 1]
                }}
              </td>
              <td class="text-center" scope="row">
                {{ round(item.size / 1000, 2) }}KB /<br />
                {{ round(item.size / 1000000, 2) }}MB
              </td>

              <td class="text-center" scope="row">
                <i
                  style="cursor: pointer"
                  class="fa fa-download ms-2"
                  (click)="requestSummarizedPositionsListFile(item.fileName)"
                  aria-hidden="true"
                ></i>
                <i
                  style="cursor: pointer; color: blue"
                  class="fa fa-search ms-2"
                  (click)="
                    openModalSummarizedPositionSeriaisSearch(
                      modalSummarizedReportPositionSeriais,
                      item.fileName
                    )
                  "
                  aria-hidden="true"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalSummarizedReportPositionSeriais let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Seriais para pesquisar no arquivo</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>

  <div class="modal-body mb-2">
    <div class="input-group input-group-sm mb-3">
      <label class="input-group-text" id="inputGroup-seriais">Seriais</label>
      <input
        [(ngModel)]="seriaisSummarizedPositionSearch.seriais"
        type="text"
        class="form-control"
        required
        aria-describedby="inputGroup-seriais"
        placeholder="Inserir os seriais separados por ;"
      />
    </div>
    <button
      type="submit"
      class="btn btn-primary"
      (click)="
        requestSummarizedPositionsListSerialSearch();
        modal.dismiss('Cross click')
      "
    >
      Pesquisar
    </button>
  </div>
</ng-template>
